import React from "react";
import { Navigate, useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import { useEffect } from "react";

const ProtectedRoute = ({ children }) => {


    const navigate = useNavigate();

    
    useEffect(() => {
        const token = sessionStorage.getItem("authToken");
        if (!token) {
            navigate("/signin", { replace: true });
        }
    }, [navigate]);

    const token = sessionStorage.getItem("authToken");
    if (!token) {
        return <Navigate to="/signin" replace />;
    }

    return children;


};

ProtectedRoute.propTypes = {
    children: PropTypes.node.isRequired,
};

export default ProtectedRoute;
